<div class="hts-assistant-message" [class.hts-assistant-message--user]="isUser" [class.hts-assistant-message--dimmed]="isDimmed">
  <div class="hts-assistant-message__bubble">{{ content }}</div>
</div>
